/* eslint-disable jsx-a11y/href-no-hash, jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import faEnvelope from '@fortawesome/fontawesome-free-solid/faEnvelope';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import Button from './common/Button';
import Modal from './Modal';
import FeedbackForm from './common/FeedbackForm';
import User from '../models/User';
import AvatarImage from './common/AvatarImage';
import './Header.css';

class Header extends React.PureComponent {
  state = {
    visible: false,
  };

  showModal = this.showModal.bind(this);
  hideModal = this.hideModal.bind(this);

  showModal() {
    this.setState({ visible: true });
  }

  hideModal() {
    this.setState({ visible: false });
  }

  render() {
    const { pageTitle, user, onLogout } = this.props;

    const handleOpen = () => {
      this.setState({ visible: !this.state.visible });
    };

    return (
      <div className="appHeader">
        <h1 className="appHeader-title">{pageTitle}</h1>
        {/*
        <Button
          label={
            <React.Fragment>
              <FontAwesomeIcon icon={faEnvelope} className="icon" size="sm" />{' '}
              <span>Send Feedback</span>
            </React.Fragment>
          }
          handler={handleOpen}
        />
        <Modal visible={this.state.visible}>
          <FeedbackForm pageName={pageTitle} closeDialog={this.hideModal} />
        </Modal> */}

        <nav className="appHeader-account accountWidget">
          <AvatarImage className="accountWidget-avatar" />
          <span className="accountWidget-username">{user.firstName} &nbsp; ▼</span>
          <aside className="accountWidget-dropdown box menu">
            <ul className="menu-list">
              <li>
                <Link to="/settings">Account</Link>
              </li>
              <li>
                <a href="#" role="button" onClick={onLogout}>
                  Log Out
                </a>
              </li>
            </ul>
          </aside>
        </nav>
      </div>
    );
  }
}

Header.propTypes = {
  pageTitle: PropTypes.string,
  user: PropTypes.instanceOf(User).isRequired,
  onLogout: PropTypes.func.isRequired,
};

Header.defaultProps = {
  pageTitle: '',
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.jsx